import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, Divider, Paper } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import InfiniteScroll from "react-infinite-scroll-component";
import UseDateTimeFormat from "../../hooks/useDateTimeFormat";
import useHistory from "./hook/useHistory";
import moment from "moment";

const InventoryHistory = () => {
  const { getFormattedDateTime } = UseDateTimeFormat();
  const { data, methods } = useHistory();
  const { assignHistory, productDetails } = data;
  const { fetchMoreData } = methods;
  const [activeTab, setActiveTab] = useState("timeline");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // ✅ Timeline rendering
  const TimeLine = () => (
    <>
      {assignHistory && assignHistory.length > 0 ? (
        assignHistory.map((item, index) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent color="text.secondary">
              {getFormattedDateTime(item?.createdAt, "calendar")}
              <div>
                By:{" "}
                {item?.createdby_id?.firstName
                  ? `${item.createdby_id.firstName} ${item.createdby_id.lastName}`
                  : "--"}
              </div>
            </TimelineOppositeContent>

            <TimelineSeparator>
              <TimelineDot />
              {index !== assignHistory.length - 1 && <TimelineConnector />}
            </TimelineSeparator>

            <TimelineContent>
             {item?.title}
              <div className="mt-2">
                {Object.keys(item?.data || {}).map((key) => {
                  let newKey = key.split("_").join(" ").toUpperCase();
                  let value = item.data[key];

                  if (key === "appliedStartDate" || key === "appliedEndDate") {
                    value = getFormattedDateTime(value, "DD-MM-YYYY");
                    newKey =
                      key === "appliedStartDate"
                        ? "Applied Start Date"
                        : "Applied End Date";
                  } else if (key === "denialReason") {
                    newKey = "Denial Reason";
                  } else if (key === "leaveType") {
                    newKey = "Leave Type";
                  }

                  return (
                    <div key={key}>
                      <strong>{newKey}:</strong>{" "}
                      <span
                        className="text-break"
                        dangerouslySetInnerHTML={{ __html: value }}
                      />
                    </div>
                  );
                })}
              </div>
            </TimelineContent>
          </TimelineItem>
        ))
      ) : (
        <div
          className="d-flex justify-content-center align-items-center border border-1"
          style={{ margin: 0, height: "100px" }}
        >
          <span>No record found</span>
        </div>
      )}
    </>
  );

  return (
    <Box className="mt-3 inventory-history">
      {/* ✅ Top Product Details Card */}
      {productDetails && (
        <Paper
          elevation={0}
          className="p-4 border rounded bg-white"
          sx={{
            borderColor: "#dcdcdc",
            borderWidth: "1px",
            borderStyle: "solid",
          }}
        >
          <div className="row">
            <p className="col-lg-6 col-md-6 mb-2">
              <strong>Product Name:</strong>{" "}
              <span className="text-muted">
                {productDetails?.employee_id?.firstName || ""}{" "}
                {productDetails?.employee_id?.lastName || ""}
              </span>
            </p>
            <p className="col-lg-6 col-md-6 mb-2">
              <strong>Date:</strong>{" "}
              <span className="text-muted">
                {moment(productDetails?.dateOfAssign).format("YYYY-MM-DD")}
              </span>
            </p>
            <p className="col-lg-6 col-md-6 mb-2">
              <strong>Assign/Use Quantity:</strong>{" "}
              <span className="text-muted">
                {productDetails?.assignQuantity}
              </span>
            </p>
            <p className="col-lg-6 col-md-6 mb-2">
              <strong>Type Of Assign/Use:</strong>{" "}
              <span className="text-muted">{productDetails?.typeOfAssign}</span>
            </p>
          </div>
        </Paper>
      )}

      {/* ✅ Tabs */}
      <Box
        className="border bg-white mt-3 rounded-top"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          width: "100%",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label="TIMELINE"
            value="timeline"
            sx={{ textTransform: "none", fontWeight: 600 }}
          />
        </Tabs>
      </Box>

      {/* ✅ Timeline Section */}
      {activeTab === "timeline" && (
        <Box
          id="scrollableDiv"
          sx={{
            maxHeight: "70vh",
            overflowY: "auto",
            backgroundColor: "#fafafa",
            border: "1px solid #e5e5e5",
            borderTop: "none",
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
            p: 2,
          }}
        >
          <InfiniteScroll
            dataLength={assignHistory?.length || 0}
            next={fetchMoreData}
            hasMore={true}
            scrollableTarget="scrollableDiv"
          >
            <Timeline position="alternate">{TimeLine()}</Timeline>
          </InfiniteScroll>
        </Box>
      )}
    </Box>
  );
};

export default InventoryHistory;
